module.exports = __webpack_public_path__ + "img/VL_14_01.c526a40e.png";